'use client';

import PulsatingButton from '@/components/ui/PulsatingButton';
import { sendYMEvent, YM_TARGETS_ENUM } from '@/shared/const/ym';
import { Link } from '@/shared/navigation';
import { ROUTES } from '@/shared/routes/routes';

export const HomeFinalCta = () => {
  return (
    <section
      className="w-full py-12 md:py-16"
      aria-labelledby="home-final-cta-heading"
    >
      <div className="mx-auto max-w-2xl rounded-3xl border border-default-200 bg-gradient-to-br from-warning/10 via-content1 to-content1 px-6 py-10 text-center shadow-sm md:px-10 dark:from-warning/5 dark:via-default-100/20">
        <h2
          id="home-final-cta-heading"
          className="text-2xl font-bold text-foreground md:text-3xl"
        >
          Выбери свой первый мастер-класс
        </h2>
        <p className="mt-3 text-default-600 md:text-lg">
          Схемы, пошаговые объяснения и понятные материалы — чтобы игрушка
          получилась с первого раза.
        </p>
        <div className="mt-8 flex justify-center">
          <Link href={ROUTES.masterclasses}>
            <PulsatingButton
              duration="2s"
              onClick={() => sendYMEvent(YM_TARGETS_ENUM.GO_TO_MASTERCLASSES)}
            >
              Перейти в каталог
            </PulsatingButton>
          </Link>
        </div>
      </div>
    </section>
  );
};
